module.exports = __webpack_public_path__ + "img/up-arrow.32547891.svg";